import COLORS from '@/pages/Metrics/configs/colors';

const campaignStatusChartConfig = {
  name: 'campaign_status_counts',
  title: 'Campaign Status Counts',
  metric: 'campaign_status_counts',
  helpText: 'The <i>Campaign Status Counts</i> graph displays the total number of campaigns for each status during the specified date range.',
  lines: {
    executed_count: {
      label: 'Executed',
      position: 1,
      color: COLORS.orange,
    },
    deleted_count: {
      label: 'Deleted',
      position: 2,
      color: COLORS.yellow,
    },
    stopped_count: {
      label: 'Stopped',
      position: 3,
      color: COLORS.blood_red,
    },
    pending_count: {
      label: 'Pending',
      position: 4,
      color: COLORS.grass,
    },
    total: {
      label: 'Total Campaigns',
      position: 5,
      color: COLORS.medium_turquoise,
      type: 'spline',
    },
  },
};

export default campaignStatusChartConfig;
